<template>
    <div class="ClientReferral">
        <h2>Client Referrals <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" /></h2>
        <div class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Status:</label>
                        <select class="form-control" v-model="Filters.Status">
                            <option value="All">All</option>
                            <option value="ENROLLED">ENROLLED</option>
                            <option value="NOT PLACED">NOT PLACED</option>
                            <option value="UNDER REVIEW">UNDER REVIEW</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Program:</label>
                        <select class="form-control" v-model="Filters.SubProgramID">
                            <option v-if="CheckPermission('CanAccessAllOptionInSubPrograms')" value="">All</option>
                            <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Referrals:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    Displaying {{NumberOfReferrals}} Records
                </div>
            </div>
        </div>
        <div class="container-fluid container-fill">
            <div class="row">
                <b-button style="margin-top:1rem;margin-bottom:1rem;" variant="olive-green" @click="OpenCreateReferralModal()">Create Referral</b-button>
            </div>
            <div class="row" style="overflow-x:auto;">

                <vuetable :fields="ReferralTableOptions.Fields"
                          :data-manager="DataManager"
                          pagination-path=""
                          :api-mode="false"
                          ref="datatable">
                    <template slot="ReferralActions" scope="props">
                        <div class="ReferralActionDiv">
                            <b-row no-gutters>
                                <b-col md="auto">
                                    <span v-if="props.rowData.ReferralPacketFileID" style="font-size:20px;margin-right:0.6rem;"><font-awesome-icon :icon="['fa', 'eye']" v-on:click="ViewDocument(props.rowData.ReferralPacketFileID, 'ReferralPacket.pdf','ReferralPacket.pdf')" class="pointer" /></span>
                                    <font-awesome-icon :icon="['fa', 'edit']" style="font-size: 20px; margin-right:0.5rem;" class="pointer orange " @click="UpdateReferralButton(props.rowData)" />
                                    <ActionButtonWithIcon :requires-confirmation="true"
                                              confirmation-string="WARNING: You are about to delete this referral.  Are you sure?"
                                              endpoint="ClientReferral/DeleteReferral"
                                              :payload="{Id: props.rowData.Id}"
                                              :perform-global-update="false"
                                              button-variant="success"
                                              button-string=""
                                              button-size="md"
                                              emit-on-success="role-deleted"
                                              v-on:success="RefreshDataTable" 
                                              icon-prefix="fa"
                                              icon-suffix="trash-alt"
                                              icon-color="red"
                                              method="POST"/>
                                </b-col>
                            </b-row>
                        </div>
                    </template>
                    <template slot="Enroll" scope="props">
                        <div class="Enroll">
                            <b-row no-gutters>
                                <b-col md="auto">
                                    <b-button v-if="props.rowData.Status == 'UNDER REVIEW' || props.rowData.Status == 'ACCEPTABLE'" variant="olive-green" @click="OpenEnrollIntoProgramModal(props.rowData)">
                                        <span>
                                            ENROLL INTO PROGRAM
                                        </span>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                    </template>
                </vuetable>
            </div>
            <b-modal @show="ClearForm" @hidden="ClearForm" ref="create-referral-modal" title="Create Referral" hide-footer size="lg">
                <b-container fluid>
                    <b-form @submit="CreateReferral">
                        <b-row>
                            <b-col cols="12"><b>Client First Name:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.ClientFirstName" type="name" required></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Client Last Name:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.ClientLastName" type="name" required></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Client Date of Birth:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <flat-pickr class="form-control" v-model="form.DOB" :config="DateConfig" required></flat-pickr>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Race:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.RaceID" required>
                                    <option v-for="race in RaceOptions" :value="race.value">
                                        {{ race.text }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Ethnicity:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.EthnicityID" required>
                                    <option v-for="ethnicity in EthnicityOptions" :value="ethnicity.value">
                                        {{ ethnicity.text }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Sex:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.SexID" required>
                                    <option v-for="sex in SexOptions" :value="sex.value">
                                        {{ sex.text }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Sub Program:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.SubProgramID" required>
                                    <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Program Designation:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.ProgramDesignation" required>
                                    <option v-for="programDesignation in ProgramDesignations" :value="programDesignation.value">
                                        {{ programDesignation.text }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Referral Date:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <flat-pickr class="form-control" v-model="form.ReferralDate" :config="DateConfig" required></flat-pickr>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Agency:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.AgencyID" required>
                                    <option v-for="agency in AgencyOptions" :value="agency.value">
                                        {{ agency.text }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Referred By:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.ReferredByName" type="name" required></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Status:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.Status" required>
                                    <option value="NOT PLACED">NOT PLACED</option>
                                    <option value="UNDER REVIEW">UNDER REVIEW</option>
                                    <option value="ACCEPTABLE">ACCEPTABLE: No Beds Available</option>
                                </select>
                            </b-col>
                        </b-row>
                        <div v-if="form.Status == 'NOT PLACED'">
                            <b-row>
                                <b-col cols="12"><b>Reason Not Placed (Disposition):</b></b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" style="margin-bottom: 1rem">
                                    <select class="form-control" v-model="form.RejectionReason">
                                        <option value=""></option>
                                        <option v-for="rejectionReasons in RejectionReasons" :value="rejectionReasons.value">
                                            {{ rejectionReasons.text }}
                                        </option>
                                    </select>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" style="margin-bottom: 1rem">
                                    <input type="text" class="form-control" v-model="form.RejectionNotes" placeholder="Notes on Disposition" />
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else-if="form.RejectionReason = ''"></div>
                        <b-row>
                            <b-col cols="12"><b>Comments:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="5" v-model="form.Comments" type="name"></b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelModal('create-referral-modal')">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="primary" type="submit">
                                    CONFIRM
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
            <b-modal ref="update-referral-modal" title="Update Referral" hide-footer size="lg">
                <b-container fluid>
                    <b-form @submit="UpdateReferral">
                        <b-row>
                            <b-col cols="12"><b>Client First Name:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.ClientFirstName" type="name" required></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Client Last Name:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.ClientLastName" type="name" required></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Client Date of Birth:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <flat-pickr class="form-control" v-model="form.DOB" :config="DateConfig" required></flat-pickr>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Race:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.RaceID" required>
                                    <option v-for="race in RaceOptions" :value="race.value">
                                        {{ race.text }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Ethnicity:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.EthnicityID" required>
                                    <option v-for="ethnicity in EthnicityOptions" :value="ethnicity.value">
                                        {{ ethnicity.text }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Sex:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.SexID" required>
                                    <option v-for="sex in SexOptions" :value="sex.value">
                                        {{ sex.text }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Sub Program:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.SubProgramID" required @change="GetFormMembershipsForSubProgram">
                                    <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Program Designation:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.ProgramDesignation" required>
                                    <option v-for="programDesignation in ProgramDesignations" :value="programDesignation.value">
                                        {{ programDesignation.text }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Referral Date:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <flat-pickr class="form-control" v-model="form.ReferralDate" :config="DateConfig" required></flat-pickr>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Agency:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.AgencyID" required>
                                    <option v-for="agency in AgencyOptions" :value="agency.value">
                                        {{ agency.text }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Referred By:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.ReferredByName" type="name" required></b-col>
                        </b-row>
                        <span v-if="form.Status != 'ENROLLED'">
                            <b-row>
                                <b-col cols="12"><b>Status:</b></b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" style="margin-bottom: 1rem">
                                    <select class="form-control" v-model="form.Status" required>
                                        <option value="NOT PLACED">NOT PLACED</option>
                                        <option value="UNDER REVIEW">UNDER REVIEW</option>
                                        <option value="ACCEPTABLE">ACCEPTABLE: No Beds Available</option>
                                    </select>
                                </b-col>
                            </b-row>
                        </span>
                        <div v-if="form.Status == 'Rejected'">
                            <b-row>
                                <b-col cols="12"><b>Reason Not Placed (Disposition):</b></b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" style="margin-bottom: 1rem">
                                    <select class="form-control" v-model="form.RejectionReason">
                                        <option value=""></option>
                                        <option v-for="rejectionReasons in RejectionReasons" :value="rejectionReasons.value">
                                            {{ rejectionReasons.text }}
                                        </option>
                                    </select>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" style="margin-bottom: 1rem">
                                    <input type="text" class="form-control" v-model="form.RejectionNotes" placeholder="Notes on Disposition" />
                                </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col cols="12"><b>Comments:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="5" v-model="form.Comments" type="name"></b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Add New Document:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <NewDocument :chart-record-id="form.Id" :form-memberships-import="TargetSubProgramForms" chart-type="ReferralTracking" />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12"><b>Documents:</b></b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <CaseFile :chart-record-id="form.Id" :sub-program-id="form.SubProgramID" chart-type="ReferralTracking"/>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelModal('update-referral-modal')">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="primary" type="submit">
                                    CONFIRM
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
            <b-modal ref="enroll-into-program-modal" title="Enroll into program" hide-footer>
                <b-container fluid>
                    <b-form @submit="EnrollReferralIntoSubProgram">
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Start Date:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <flat-pickr class="form-control" v-model="form.StartDate" :config="DateConfig" required></flat-pickr>
                            </b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Location:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.ResidenceID" required>
                                    <option v-for="residence in ResidenceList" v-bind:value="residence.Id">{{ residence.Name }}</option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelModal('enroll-into-program-modal')">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="primary" type="submit">
                                    CONFIRM
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
            <DocumentViewer ref="document-viewer-modal-component" :reviewing="false" />
        </div>
    </div>

</template>
<script>
    //import services
    //import { UserAPI } from '../../services/api/Core/UserAPI.js';
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import DocumentViewer from "../Core/RecordComponents/DocumentViewer.vue";
    import NewDocument from "../Core/RecordComponents/NewDocument.vue";
    import CaseFile from "../Core/RecordComponents/CaseFile.vue";
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { EventBus } from '../../services/event-bus.js';
    export default {
        data: function () {
            return {
                sitelogo: "/images/OliveCrestLogo_Banner_Portal.png",
                search: "",
                ReferralsList: [],
                CheckedInUsers: [],
                ClickedOnUser: {},
                Residences: [],
                Clients: [],
                NumberOfReferrals: '',
                ReferralTrackingObject: {},
                ResidenceList: [],
                form: {
                    Id:'',
                    ReferralDate: '',
                    ClientID: '',
                    SubProgramID: '',
                    AgencyID: '',
                    ReferredByName: '',
                    Status: '',
                    Comments: '',
                    ClientFirstName: '',
                    ClientLastName: '',
                    DOB: '',
                    StartDate: '',
                    ResidenceID: '',
                    SexID: '',
                    EthnicityID: '',
                    RaceID: '',
                    RejectionReason: '',
                    RejectionNotes: '',
                    ProgramDesignation: '',
                    File: '',
                    ReferralPacketFileName: '',
                    ReferralPacketFileID: ''
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
                Filters: {
                    Status: "UNDER REVIEW",
                    SubProgramID: "",
                },
                TargetSubProgramForms: [],
                 ReferralTableOptions: {
                    Fields: [
                        {
                            name: 'Client.Person.FullName',
                            title: 'Name',
                            sortField: 'Client.Person.FullName'
                        },
                        {
                            name: 'SubProgram.Name',
                            title: 'Program',
                            sortField: 'SubProgram.Name'
                        },
                        {
                            name: 'Agency.Name',
                            title: 'Agency',
                            sortField: 'Agency.Name'
                        },
                        {
                            name: 'Status',
                            title: 'Status',
                            sortField: 'Status'
                         },
                        {
                            name: 'ProgramDesignation',
                            title: 'Program Designation',
                            sortField: 'ProgramDesignation'
                        },
                        {
                            name: 'ReferralDate',
                            title: 'Date Referred',
                            sortField: 'ReferralDate',
                            callback: 'formatDate|MM/DD/YY'
                        },
                        {
                            name: 'ReferredByName',
                            title: 'Referred By',
                            sortField: 'ReferredByName'
                        },
                        {
                            name: 'Comments',
                            title: 'Comments',
                            sortField: 'Comments'
                        },
                        {
                            name: '__slot:ReferralActions',
                            title: 'Actions'
                         },
                        {
                            name: '__slot:Enroll',
                            title: 'Enroll'
                        }
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetReferrals();
            },
            CreateReferral(e) {
                e.preventDefault();
                let vm = this;
                let form = this.$refs['uploadFile'];
                let formData = new FormData(form);
                formData.append("File", vm.form.File);
                formData.append("SubProgramID", vm.form.SubProgramID);
                formData.append("AgencyID", vm.form.AgencyID);
                formData.append("ReferredByName", vm.form.ReferredByName);
                formData.append("ReferralDate", vm.form.ReferralDate);
                formData.append("Status", vm.form.Status);
                formData.append("Comments", vm.form.Comments);
                formData.append("ClientFirstName", vm.form.ClientFirstName);
                formData.append("ClientLastName", vm.form.ClientLastName);
                formData.append("DOB", vm.form.DOB);
                formData.append("SexID", vm.form.SexID);
                formData.append("EthnicityID", vm.form.EthnicityID);
                formData.append("RaceID", vm.form.RaceID);
                formData.append("ProgramDesignation", vm.form.ProgramDesignation);
                formData.append("RejectionReason", vm.form.RejectionReason);
                formData.append("RejectionNotes", vm.form.RejectionNotes);
                formData.append("ProgramDesignation", vm.form.ProgramDesignation);
                vm.$MasterAPI.ExecuteRequest("POST", "ClientReferral/CreateReferral", formData, this.CreateReferralSuccess, () => { }, true);
            },
            CreateReferralSuccess(response) {
                this.RefreshDataTable();
                this.$refs['create-referral-modal'].hide();
            },
            UpdateReferral(e) {
                e.preventDefault();
                let vm = this;
                let form = this.$refs['uploadFile'];
                let formData = new FormData(form);
                formData.append("File", vm.form.File);
                formData.append("Id", vm.form.Id);
                formData.append("SubProgramID", vm.form.SubProgramID);
                formData.append("AgencyID", vm.form.AgencyID);
                formData.append("ReferredByName", vm.form.ReferredByName);
                formData.append("ReferralDate", vm.form.ReferralDate);
                formData.append("Status", vm.form.Status);
                formData.append("Comments", vm.form.Comments);
                formData.append("ClientFirstName", vm.form.ClientFirstName);
                formData.append("ClientLastName", vm.form.ClientLastName);
                formData.append("DOB", vm.form.DOB);
                formData.append("SexID", vm.form.SexID);
                formData.append("EthnicityID", vm.form.EthnicityID);
                formData.append("RaceID", vm.form.RaceID);
                formData.append("ProgramDesignation", vm.form.ProgramDesignation);
                formData.append("RejectionReason", vm.form.RejectionReason);
                formData.append("RejectionNotes", vm.form.RejectionNotes);
                formData.append("ProgramDesignation", vm.form.ProgramDesignation);
                vm.$MasterAPI.ExecuteRequest("POST", "ClientReferral/UpdateReferral",
                    formData, this.UpdateReferralSuccess, () => { }, true);
            },
            UpdateReferralSuccess(response) {
                  this.RefreshDataTable();
                  this.$refs['update-referral-modal'].hide();
            },
            UpdateReferralButton(rowData) {
                this.form.Id = rowData.Id;
                this.form.SubProgramID = rowData.SubProgramID,
                this.form.AgencyID = rowData.AgencyID;
                this.form.ReferredByName = rowData.ReferredByName;
                this.form.Status = rowData.Status;
                
                this.form.ClientFirstName = rowData.Client.Person.FirstName;
                this.form.ClientLastName = rowData.Client.Person.LastName;
                this.form.DOB = rowData.Client.Person.DOB;
                this.form.ReferralDate = rowData.ReferralDate
                this.form.SexID = rowData.Client.Person.SexID;
                this.form.EthnicityID = rowData.Client.Person.EthnicityID;
                this.form.RaceID = rowData.Client.Person.RaceID;
                this.form.ProgramDesignation = rowData.ProgramDesignation;
                this.form.RejectionReason = rowData.RejectionReason;
                this.form.RejectionNotes = rowData.RejectionNotes;
                if (rowData.Comments == null) {
                    this.form.Comments = '';
                }
                else {
                    this.form.Comments = rowData.Comments;
                }
                if (rowData.ReferralPacketFile != null) {
                    this.form.ReferralPacketFileName = rowData.ReferralPacketFile.Name;
                    this.form.ReferralPacketFileID = rowData.ReferralPacketFile.Id
                }
                else {
                    //reset referral packet form if does not exist on rowdata
                    this.form.ReferralPacketFileID = null;
                    this.form.ReferralPacketFileName = null;
                }

                this.TargetSubProgramForms = [];
                this.GetFormMembershipsForSubProgram(this.form.SubProgramID);
            },
            //GetAgencies() {
            //    let vm = this;
            //    let subProgramIDs = [];
            //    for (var i = 0; i < this.SubProgramOptions.length; i++) {
            //        subProgramIDs[i] = this.SubProgramOptions[i].value;
            //    }
            //    vm.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/GetAgenciesByCoreProgramID", { SubProgramIDs: subProgramIDs })
            //        .then((response) => {
            //            vm.Agencies = response.data.data;
            //        }).catch((error) => console.log(error));  
            //},
            GetReferrals() {
                this.$MasterAPI.ExecuteRequest("GET", "ClientReferral/GetReferrals", { Status: this.Filters.Status, SubProgramID: this.Filters.SubProgramID }, this.GetReferralsSuccess, () => { }, true);
            },
            GetReferralsSuccess(response) {
                this.ReferralsList = response.data.data;
                this.$refs.datatable.refresh();
            },
            GetFormMembershipsForSubProgram() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/GetFormMembershipsForSubProgram", { SubProgramID: this.form.SubProgramID, ChartType: "ReferralTracking" }, this.GetFormMembershipsForSubProgramSuccess, () => { }, true);
            },
            GetFormMembershipsForSubProgramSuccess(response) {
                this.TargetSubProgramForms = response.data.data;
                this.$refs['update-referral-modal'].show();
            },
            UploadFile() {
                let vm = this;
                vm.$MasterAPI.ExecuteRequest("POST", "Core/Files/UploadFile", {}, () => {}, () => { }, false);
            },
            GetResidences() {
                let subProgramIDs = [];
                for (var i = 0; i < this.SubProgramOptions.length; i++) {
                    subProgramIDs[i] = this.SubProgramOptions[i].value;
                }
                this.$MasterAPI.ExecuteRequest("POST", "TAY/Residences/GetResidencesBySubPrograms", { SubProgramIDs: subProgramIDs }, this.GetResidencesSuccess, () => { }, false);
            },
            GetResidencesSuccess(response) {
                 this.ResidenceList = response.data.data;
            },
            EnrollReferralIntoSubProgram(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "ClientReferral/EnrollReferralIntoSubProgram", { ReferralTracking: this.ReferralTrackingObject, StartDate: this.form.StartDate, ResidenceID: this.form.ResidenceID }, this.EnrollReferralIntoSubProgramSuccess, () => { }, false);
            },
            EnrollReferralIntoSubProgramSuccess(response) {
                 this.RefreshDataTable();
                 this.$refs['enroll-into-program-modal'].hide();
            },
            ClearForm() {
                this.form.ReferralDate = '';
                this.form.SubProgramID = '';
                this.form.AgencyID = '';
                this.form.ReferredByName = '';
                this.form.Status = 'Pending';
                this.form.Comments = '';
                this.form.ClientFirstName = '';
                this.form.ClientLastName = '';
                this.form.RejectionReason = '';
                this.form.RejectionNotes = '';
                this.form.ProgramDesignation = '';
                this.form.DOB = '';
                this.form.RaceID = '';
                this.form.EthnicityID = '';
                this.form.SexID = '';
                this.form.ReferralPacketFileID = null;
                this.form.ReferralPacketFileName = null;

            },
            OpenCreateReferralModal() {
                //this.ClickedOnUser = user;
                this.$refs['create-referral-modal'].show();
            },
            HideCreateReferralModal() {
                this.$refs['create-referral-modal'].hide();
            },
            CancelModal(modalRef) {
                this.$refs[modalRef].hide();
            },
            RefreshUpdateModal() {
                this.form.ReferralPacketFileID = null;
                this.form.ReferralPacketFileName = null;
                this.RefreshDataTable();
            },
            OpenEnrollIntoProgramModal(rowData) {
                this.form.StartDate = '';
                this.form.ResidenceID = '';
                this.ReferralTrackingObject = rowData;
                this.$refs['enroll-into-program-modal'].show();
            },
            ViewDocument(pdfFileID, formLabel, documentName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.ReferralsList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfReferrals = visibleData.length;
                return visibleData;                  
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        mounted() {
            this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            this.GetReferrals();
            this.GetResidences();
        },
        components: {
            flatPickr,
            Vuetable,
            ActionButtonWithIcon,
            DocumentViewer,
            NewDocument,
            CaseFile
        },
        computed: {
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            SexOptions: function () {
                return this.$store.state.Options.Sexes;
            },
            RaceOptions: function () {
                return this.$store.state.Options.Races;
            },
            EthnicityOptions: function () {
                return this.$store.state.Options.Ethnicities;
            },
            RejectionReasons: function () {
                return this.$store.state.Options.RejectionReasons;
            },
            ProgramDesignations: function () {
                return this.$store.state.Options.ProgramDesignations;
            },
            AgencyOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramAgencyOptions"](this.form.SubProgramID);
            },
        }
    }
</script>


<style scoped>
    .upper-right {
        position: absolute;
        top: 0;
        right: 40px;
    }
    .btn-olive-green {
        background-color: #94A545 !important;
        color: white;
        box-shadow:none;
    }
</style>